import { render, staticRenderFns } from "./ItemizerSteps.vue?vue&type=template&id=3e88ea0e&scoped=true&"
import script from "./ItemizerSteps.vue?vue&type=script&lang=js&"
export * from "./ItemizerSteps.vue?vue&type=script&lang=js&"
import style0 from "./ItemizerSteps.vue?vue&type=style&index=0&id=3e88ea0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88ea0e",
  null
  
)

export default component.exports